import { getClusterScales, filterSimpleByScale } from './simple';
import { getCustomClusterScales, filterCustomByScale } from './custom';

export const scalesFilter = (searchResults, scaleSelected, isCustom) => {
  if (!scaleSelected || scaleSelected === 'allOptions') {
    return [...searchResults];
  }

  const filterByScale = isCustom ? filterCustomByScale : filterSimpleByScale;
  return filterByScale(searchResults, scaleSelected);
};

export const getScalesBySearchType = isCustomSearch =>
  isCustomSearch ? getCustomClusterScales : getClusterScales;
